import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconName } from '@app/core/models/icons.model';

type FontSize =
  | `${number}px`
  | `${number}em`
  | `${number}rem`
  | `${number}%`
  | 'small'
  | 'medium'
  | 'large'
  | 'inherit'
  | 'initial'
  | 'unset';

@Component({
  selector: 'adspt-icon',
  template: `<svg [attr.width]="size()" [attr.height]="size()">
    <use [attr.xlink:href]="iconHref()"></use>
  </svg>`,
  styles: [
    `
      :host {
        display: inline-flex;
        &.rotate-90 {
          transform: rotate(-90deg);
        }
        &.rotate-180 {
          transform: rotate(180deg);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly name = input<IconName>();

  readonly size = input<FontSize>('1em');

  readonly iconHref = computed(() => `#adspt-${this.name()}`);
}
